import { PaymentMethodsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { Component } from '../../../../constants/CallbackConstants';
import { ERRORS } from '../../../../constants/Errors';
import { doFireStatusUpdate } from '../../../../utils/CallbackUtils';
import { sendNewRelicMessage } from '../../../../utils/NewRelicUtils';
import { AppMode } from '../../../AppModeState/AppModeState.types';
import { saveConfigs } from '../../../ConfigState/ConfigState.actions';
import { venmoInitialize } from '../../../MopOnFileState/MopOnFileState.actions';
/**
 * If user has no mop on file, Submit Payment method form
 * @param dispatch
 * @param mode
 */
export var submitPaymentMethod = function submitPaymentMethod(dispatch, mode, venmo) {
  var venmoInitialized = venmo === null || venmo === void 0 ? void 0 : venmo.venmoInitialized;
  //If a user has no MOP on file, we still want the one-click submit functionality.
  if (mode === AppMode.ADD) {
    // If user is on venmo billing address step, we need to submit Venmo mop
    // If user is on Credit card form step, we need to submit Credit card mop
    venmoInitialized ? dispatch(venmoInitialize({
      venmoSubmit: true
    })) : dispatch(saveConfigs({
      submit: true
    }));
  } else {
    sendNewRelicMessage("Fetch Payment Methods Error: User has no selected mop, appMode = ".concat(mode));
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.EXECUTE_COMMAND_LOGIC,
        errors: [ERRORS.NO_SELECTED_MOP]
      }
    }]);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/submitPaymentMethod.js
// module id = 4406
// module chunks = 11